var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "before-and-after-comparison",
          attrs: {
            visible: _vm.visible,
            title: _vm.$t("ChangeCharge.details"),
            width: "1300px",
            "close-on-click-modal": false,
            "show-close": false,
            top: "10vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            open: _vm.showDialog
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { padding: "0 0 0 10px", height: "28px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "60px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("ChangeCharge.modifyBefore")))]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "120px", padding: "0" },
              attrs: { id: "vsPage1" }
            },
            [
              _c("cargo-ag-grid", {
                key: "chargeGrid1",
                staticStyle: { height: "120px", width: "100%" },
                attrs: {
                  "grid-params": _vm.chargeBeforeGrid.gridParams,
                  "grid-options": _vm.chargeBeforeGrid.gridOptions,
                  "column-defs": _vm.chargeBeforeGridColumnDefs,
                  "row-data": _vm.chargeBeforeRowData,
                  "show-side-bar": true,
                  "auto-fit-content": false,
                  "min-height": "150"
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.chargeBeforeGrid, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.chargeBeforeGrid, "gridParams", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "padding-right": "10px",
                height: "30px",
                "background-color": "#f5f7f7"
              }
            },
            [
              _c("span", {
                staticStyle: { "font-size": "13px" },
                domProps: {
                  textContent: _vm._s(_vm.$t("ChangeCharge.estimateProfit"))
                }
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-right": "10px",
                    display: "inline-block",
                    "vertical-align": "middle"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    _vm._l(_vm.chargeOriginalProfit, function(item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("change-charge-count-item-renderer", {
                            attrs: { item: item }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { padding: "0 0 0 10px", height: "28px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "60px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("ChangeCharge.modifyAfter")))]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { height: "120px", padding: "0" },
              attrs: { id: "vsPage2" }
            },
            [
              _c("cargo-ag-grid", {
                key: "chargeGrid2",
                staticStyle: { height: "120px", width: "100%" },
                attrs: {
                  "grid-params": _vm.chargeAfterGrid.gridParams,
                  "grid-options": _vm.chargeAfterGrid.gridOptions,
                  "column-defs": _vm.chargeAfterGridColumnDefs,
                  "row-data": _vm.chargeAfterRowData,
                  "show-side-bar": true,
                  "auto-fit-content": false,
                  "min-height": "150"
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.chargeAfterGrid, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.chargeAfterGrid, "gridParams", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "padding-right": "10px",
                height: "30px",
                "background-color": "#f5f7f7"
              }
            },
            [
              _c("span", {
                staticStyle: { "font-size": "13px" },
                domProps: {
                  textContent: _vm._s(_vm.$t("ChangeCharge.estimateProfit"))
                }
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-right": "10px",
                    display: "inline-block",
                    "vertical-align": "middle"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    _vm._l(_vm.chargeChangeProfit, function(item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("change-charge-count-item-renderer", {
                            attrs: { item: item }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", margin: "2px" } },
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "1100px" },
                  attrs: { "label-position": "left", "label-width": "80px" }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("ChangeCharge.changeReason") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: true,
                              type: "textarea",
                              rows: 3,
                              resize: "none",
                              no: "1"
                            },
                            model: {
                              value: _vm.changeReason,
                              callback: function($$v) {
                                _vm.changeReason = $$v
                              },
                              expression: "changeReason"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "2" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }